/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

export default angular.module('tektelic.types', [])
    .constant('types',
        {
            eventName: {
                // GW_ALARM
                "GATEWAY_HIGH_TEMP_SHUTDOWN_ALARM": {
                    value: "GATEWAY_HIGH_TEMP_SHUTDOWN_ALARM",
                    name: "event-name.gateway-high-temp-shutdown-alarm",
                    gw: true
                },
                "GATEWAY_LOW_BATTERY_ALARM": {
                    value: "GATEWAY_LOW_BATTERY_ALARM",
                    name: "event-name.gateway-low-battery-alarm",
                    gw: true
                },
                "GATEWAY_SWITCHED_TO_BATTERY_POWER": {
                    value: "GATEWAY_SWITCHED_TO_BATTERY_POWER",
                    name: "event-name.gateway-switched-to-battery-power",
                    gw: true
                },
                "GATEWAY_SWITCH_TO_SECONDARY_NETWORK_INTERFACE_ALARM": {
                    value: "GATEWAY_SWITCH_TO_SECONDARY_NETWORK_INTERFACE_ALARM",
                    name: "event-name.gateway-switch-to-secondary-network-interface-alarm",
                    gw: true
                },
                "GATEWAY_HIGH_RAM_UTILISATION": {
                    value: "GATEWAY_HIGH_RAM_UTILISATION",
                    name: "event-name.gateway-high-ram-utilisation",
                    gw: true
                },
                "GATEWAY_HIGH_DISK_UTILISATION": {
                    value: "GATEWAY_HIGH_DISK_UTILISATION",
                    name: "event-name.gateway-high-disk-utilisation",
                    gw: true
                },
                "GATEWAY_HIGH_CPU_UTILISATION": {
                    value: "GATEWAY_HIGH_CPU_UTILISATION",
                    name: "event-name.gateway-high-cpu-utilisation",
                    gw: true
                },
                "SECURITY_ALARM": {
                    value: "SECURITY_ALARM",
                    name: "event-name.security-alarm",
                    gw: true
                },
                "STATUS_UPDATE_ALARM": {
                    value: "STATUS_UPDATE_ALARM",
                    name: "event-name.status-update-alarm",
                    gw: true
                },
                "GATEWAY_SHUTDOWN_ALARM": {
                    value: "GATEWAY_SHUTDOWN_ALARM",
                    name: "event-name.gateway-shutdown-alarm",
                    gw: true
                },
                "GATEWAY_PERFORMANCE_DEGRADE_ALARM": {
                    value: "GATEWAY_PERFORMANCE_DEGRADE_ALARM",
                    name: "event-name.gateway-performance-degrade-alarm",
                    gw: true
                },
                "GATEWAY_INTERFACE_ALARM": {
                    value: "GATEWAY_INTERFACE_ALARM",
                    name: "event-name.gateway-interface-alarm",
                    gw: true
                },

                // EVENT Gateway
                "GATEWAY_AUTHENTICATION_ERROR": {
                    value: "GATEWAY_AUTHENTICATION_ERROR",
                    name: "event-name.gateway-authentication-error",
                    gw: true
                },
                "GATEWAY_EVENTS_REPORTING_RATE_EXCEEDED": {
                    value: "GATEWAY_EVENTS_REPORTING_RATE_EXCEEDED",
                    name: "event-name.gateway-events-reporting-rate-exceeded",
                    gw: true
                },
                "GATEWAY_MQTT_RATE_EXCEEDED": {
                    value: "GATEWAY_MQTT_RATE_EXCEEDED",
                    name: "event-name.gateway-mqtt-rate-exceeded",
                    gw: true
                },
                "GATEWAY_MQTT_INVALID_FIRMWARE_REPORTED_JSON": {
                    value: "GATEWAY_MQTT_INVALID_FIRMWARE_REPORTED_JSON",
                    name: "event-name.gateway-firmware-reported-invalid-json",
                    gw: true
                },
                "GATEWAY_MQTT_INVALID_CONFIGURATION_REPORTED_JSON": {
                    value: "GATEWAY_MQTT_INVALID_CONFIGURATION_REPORTED_JSON",
                    name: "event-name.gateway-configuration-reported-invalid-json",
                    gw: true
                },
                "GATEWAY_MAC_MISMATCH": {
                    value: "GATEWAY_MAC_MISMATCH",
                    name: "event-name.gateway-mac-mismatch",
                    gw: true
                },

                // EVENT Device
                "DL_QUEUE_SIZE_EXCEEDED": {
                    value: "DL_QUEUE_SIZE_EXCEEDED",
                    name: "event-name.dl-queue-size-exceeded"
                },
                "DL_QUEUE_IS_FULL": {
                    value: "DL_QUEUE_IS_FULL",
                    name: "event-name.dl-queue-is-full"
                },
                "DEVICE_CANNOT_JOIN": {
                    value: "DEVICE_CANNOT_JOIN",
                    name: "event-name.device-cannot-join"
                },
                "TOO_FREQUENT_UPLINKS": {
                    value: "TOO_FREQUENT_UPLINKS",
                    name: "event-name.too-frequent-uplinks"
                },
                "UNKNOWN_DEVICE": {
                    value: "UNKNOWN_DEVICE",
                    name: "event-name.unknown-device"
                },
                "LORA_MIC_FAILURE": {
                    value: "LORA_MIC_FAILURE",
                    name: "event-name.lora-mic-failure"
                },
                "DEVICE_JOIN_PROCEDURE_ERROR": {
                    value: "DEVICE_JOIN_PROCEDURE_ERROR",
                    name: "event-name.device-join-procedure-error"
                },
                "DEVICE_DATA_PROCESSING_ERROR": {
                    value: "DEVICE_DATA_PROCESSING_ERROR",
                    name: "event-name.device-data-processing-error"
                },
                "INVALID_UL_FREQUENCY": {
                    value: "INVALID_UL_FREQUENCY",
                    name: "event-name.trigger-invalid-ul-frequency"
                },

                // EVENT Integration
                "INTEGRATION_DL_ENCODING_FAILURE": {
                    value: "INTEGRATION_DL_ENCODING_FAILURE",
                    name: "event-name.integration-dl-encoding-failure"
                },
                "INTEGRATION_FIRST_UL": {
                    value: "INTEGRATION_FIRST_UL",
                    name: "event-name.integration-first-ul"
                },
                "INTEGRATION_UL_DECODING_FAILURE": {
                    value: "INTEGRATION_UL_DECODING_FAILURE",
                    name: "event-name.integration-ul-decoding-failure"
                },
                "INVALID_DL_PAYLOAD": {
                    value: "INVALID_DL_PAYLOAD",
                    name: "event-name.invalid-dl-payload"
                },

                // OFFLINE
                "GATEWAY_MQTT_CONNECTION_LOST": {
                    value: "GATEWAY_MQTT_CONNECTION_LOST",
                    name: "event-name.gateway-mqtt-connection-lost",
                    gw: true
                },
                "GATEWAY_DATA_REPORTING_INTERVAL_EXCEEDED": {
                    value: "GATEWAY_DATA_REPORTING_INTERVAL_EXCEEDED",
                    name: "event-name.gateway-data-reporting-interval-exceeded",
                    gw: true
                },
                "GATEWAY_FSK_MQTT_CONNECTION_LOST": {
                    value: "GATEWAY_FSK_MQTT_CONNECTION_LOST",
                    name: "event-name.gateway-fsk-mqtt-connection-lost",
                    gw: true
                },
                "GATEWAY_FSK_DATA_REPORTING_INTERVAL_EXCEEDED": {
                    value: "GATEWAY_FSK_DATA_REPORTING_INTERVAL_EXCEEDED",
                    name: "event-name.gateway-fsk-data-reporting-interval-exceeded",
                    gw: true
                },
                "DEVICE_DATA_REPORTING_INTERVAL_EXCEEDED": {
                    value: "DEVICE_DATA_REPORTING_INTERVAL_EXCEEDED",
                    name: "event-name.device-data-reporting-interval-exceeded"
                },
                "INTEGRATION_DISCONNECTED": {
                    value: "INTEGRATION_DISCONNECTED",
                    name: "event-name.integration-disconnected"
                },
                "DECODER_BANNED": {
                    value: "DECODER_BANNED",
                    name: "event-name.decoder-banned"
                },
                "ENCODER_BANNED": {
                    value: "ENCODER_BANNED",
                    name: "event-name.encoder-banned"
                }
            },
            ituType: {
                "COMMUNICATION": {
                    value: "COMMUNICATION",
                    name: "itu-type.communication"
                },
                "QOS": {
                    value: "QOS",
                    name: "itu-type.qos"
                },
                "EQUIPMENT": {
                    value: "EQUIPMENT",
                    name: "itu-type.equipment"
                },
                "SERVICE": {
                    value: "SERVICE",
                    name: "itu-type.service"
                },
                "PERFORMANCE": {
                    value: "PERFORMANCE",
                    name: "itu-type.performance"
                },
                "ENVIRONMENTAL": {
                    value: "ENVIRONMENTAL",
                    name: "itu-type.environmental"
                },
                "SECURITY": {
                    value: "SECURITY",
                    name: "itu-type.security"
                }
            },
            enhancedEventSource: {
                "GATEWAY": {
                    value: "GATEWAY",
                    name: "enhanced-event-source.gateway"
                },
                "DEVICE": {
                    value: "DEVICE",
                    name: "enhanced-event-source.device"
                },
                "INTEGRATION": {
                    value: "INTEGRATION",
                    name: "enhanced-event-source.integration"
                }
            },
            aggregation: {
                min: {
                    value: "MIN",
                    name: "aggregation.min"
                },
                max: {
                    value: "MAX",
                    name: "aggregation.max"
                },
                avg: {
                    value: "AVG",
                    name: "aggregation.avg"
                },
                sum: {
                    value: "SUM",
                    name: "aggregation.sum"
                },
                count: {
                    value: "COUNT",
                    name: "aggregation.count"
                },
                none: {
                    value: "NONE",
                    name: "aggregation.none"
                }
            },
            apiLimitTimeUnit: {
                "HOURS": {
                    value: "HOURS",
                    name: "api-limits.time-unit-hours"
                },
                "DAYS": {
                    value: "DAYS",
                    name: "api-limits.time-unit-days"
                }
            },
            authority: {
                "SYS_ADMIN": {
                    value: "SYS_ADMIN",
                    name: "user.sys-admin",
                    scope: 'system',
                    access: 'admin'
                },
                "SYS_USER": {
                    value: "SYS_USER",
                    name: "user.sys-user",
                    scope: 'system',
                    access: 'user'
                },
                "PROVIDER_ADMIN": {
                    value: "PROVIDER_ADMIN",
                    name: "user.provider-admin",
                    scope: 'provider',
                    access: 'admin'
                },
                "PROVIDER_USER": {
                    value: "PROVIDER_USER",
                    name: "user.provider-user",
                    scope: 'provider',
                    access: 'user'
                },
                "CUSTOMER_ADMIN": {
                    value: "CUSTOMER_ADMIN",
                    name: "user.customer-admin",
                    scope: 'customer',
                    access: 'admin'
                },
                "CUSTOMER_USER": {
                    value: "CUSTOMER_USER",
                    name: "user.customer-user",
                    scope: 'customer',
                    access: 'user'
                },
                "SUB_CUSTOMER_ADMIN": {
                    value: "SUB_CUSTOMER_ADMIN",
                    name: "user.sub-customer-admin",
                    scope: 'subCustomer',
                    access: 'admin'
                },
                "SUB_CUSTOMER_USER": {
                    value: "SUB_CUSTOMER_USER",
                    name: "user.sub-customer-user",
                    scope: 'subCustomer',
                    access: 'user'
                }
            },
            allAuthorities: [
                "SYS_ADMIN",
                "SYS_USER",
                "PROVIDER_ADMIN",
                "PROVIDER_USER",
                "CUSTOMER_ADMIN",
                "CUSTOMER_USER",
                "SUB_CUSTOMER_ADMIN",
                "SUB_CUSTOMER_USER"
            ],
            adminAuthorities: [
                "SYS_ADMIN",
                "PROVIDER_ADMIN",
                "CUSTOMER_ADMIN",
                "SUB_CUSTOMER_ADMIN"
            ],
            scope: {
                system: 'system',
                provider: 'provider',
                customer: 'customer',
                subCustomer: 'subCustomer'
            },
            access: {
                admin: 'admin',
                user: 'user'
            },
            serverErrorCode: {
                general: 2,
                authentication: 10,
                jwtTokenExpired: 11,
                permissionDenied: 20,
                invalidArguments: 30,
                badRequestParams: 31,
                itemNotFound: 32,
                subscriptionViolation: 40
            },
            entryPoints: {
                login: "/api/auth/login",
                tokenRefresh: "/api/auth/token",
                revoke: "/api/auth/revoke",
                nonTokenBased: "/api/noauth"
            },
            entityType: {
                device: "DEVICE",
                application: "APPLICATION",
                gateway: "GATEWAY",
                gateway_group: "GATEWAY_GROUP",
                provider: "PROVIDER",
                customer: "CUSTOMER",
                subCustomer: "SUB_CUSTOMER",
                user: "USER",
                converter: "CONVERTER",
                converterV1: "CONVERTER_V1",
                converterV2: "CONVERTER_V2",
                integration: "INTEGRATION",
                provider_subscription: "PROVIDER_SUBSCRIPTION",
                customer_subscription: "CUSTOMER_SUBSCRIPTION",
                device_model: "DEVICE_MODEL",
                gateway_model: "GATEWAY_MODEL",
                multicast_group: "MULTICAST_GROUP"
            },
            systemActivityLogEntities: [
                "ADMIN_SETTINGS",
                "PROVIDER_SUBSCRIPTION",
                "PROVIDER",
                "USER",
                "OTHER"
            ],
            providerActivityLogEntities: [
                "CUSTOMER",
                "CUSTOMER_SUBSCRIPTION",
                "GATEWAY_MODEL",
                "GATEWAY_GROUP",
                "GATEWAY",
                "USER",
                "OTHER" 
            ],
            customerActivityLogEntities: [
                "DEVICE_MODEL",
                "CONVERTER",
                "APPLICATION",
                "DEVICE",
                "MULTICAST_GROUP",
                "INTEGRATION",
                "GATEWAY_GROUP",
                "GATEWAY",
                "SUB_CUSTOMER",
                "USER",
                "OTHER"
            ],
            subCustomerActivityLogEntities: [ 
                "DEVICE_MODEL",
                "CONVERTER",
                "APPLICATION",
                "DEVICE",
                "MULTICAST_GROUP",
                "INTEGRATION",
                "USER",
                "OTHER"
            ],
            userActivityLogBasicActions: {
                create: "CREATE",
                update: "UPDATE",
                delete: "DELETE"
            },
            userActivityLogEntityActionsMap: [
                {
                    name: "DEVICE",
                    actions: {
                        downlink_queue_add: {
                            value: "DOWNLINK_QUEUE_ADD"
                        },
                        downlink_queue_flush: {
                            value: "DOWNLINK_QUEUE_FLUSH"
                        },
                        multicast_devices_add: {
                            value: "MULTICAST_DEVICES_ADD"
                        },
                        multicast_devices_delete: {
                            value: "MULTICAST_DEVICES_DELETE"
                        },
                        network_settings_update: {
                            value: "NETWORK_SETTINGS_UPDATE"
                        },
                        device_session_update: {
                            value: "DEVICE_SESSION_UPDATE"
                        },
                        api_limit_update: {
                            value: "API_LIMIT_UPDATE"
                        },
                        mac_command_send: {
                            value: "MAC_COMMAND_SEND"
                        }
                    }
                },
                {
                    name: "GATEWAY",
                    actions: {
                        gateway_configuration_create: {
                            value: "GATEWAY_CONFIGURATION_CREATE"
                        },
                        gateway_configuration_update: {
                            value: "GATEWAY_CONFIGURATION_UPDATE"
                        },
                        gateway_configuration_delete: {
                            value: "GATEWAY_CONFIGURATION_DELETE"
                        },
                        gateway_firmware_create: {
                            value: "GATEWAY_FIRMWARE_CREATE"
                        },
                        gateway_firmware_update: {
                            value: "GATEWAY_FIRMWARE_UPDATE"
                        },
                        gateway_firmware_delete: {
                            value: "GATEWAY_FIRMWARE_DELETE"
                        },
                        gateway_jsonconfiguration_create: {
                            value: "GATEWAY_JSONCONFIGURATION_CREATE"
                        },
                        gateway_jsonconfiguration_update: {
                            value: "GATEWAY_JSONCONFIGURATION_UPDATE"
                        },
                        gateway_jsonconfiguration_delete: {
                            value: "GATEWAY_JSONCONFIGURATION_DELETE"
                        },
                        gateway_rpc_send: {
                            value: "GATEWAY_RPC_SEND"
                        }
                    }
                },
                {
                    name: "GATEWAY_GROUP",
                    actions: {
                        gateway_group_gateway_add: {
                            value: "GATEWAY_GROUP_GATEWAY_ADD"
                        },
                        gateway_group_gateway_delete: {
                            value: "GATEWAY_GROUP_GATEWAY_DELETE"
                        }
                    }
                },
                {
                    name: "USER",
                    actions: {
                        activation_email_send: {
                            value: "ACTIVATION_EMAIL_SEND"
                        },
                        activation_link_get: {
                            value: "ACTIVATION_LINK_GET"
                        },
                        password_change: {
                            value: "PASSWORD_CHANGE"
                        },
                        password_reset: {
                            value: "PASSWORD_RESET"
                        },
                        reset_token_create: {
                            value: "RESET_TOKEN_CREATE"
                        },
                        user_activate: {
                            value: "USER_ACTIVATE"
                        },
                        login_success: {
                            value: "LOGIN_SUCCESS"
                        },
                        login_failed: {
                            value: "LOGIN_FAILED"
                        },
                        user_sso_attach: {
                            value: "USER_SSO_ATTACH",
                            scope: ["provider"]
                        },
                        user_sso_login: {
                            value: "USER_SSO_LOGIN",
                            scope: ["provider", "customer"]
                        }
                    }
                },
                {
                    name: "ADMIN_SETTINGS",
                    actions: {
                        test_email_send: {
                            value: "TEST_EMAIL_SEND"
                        },
                        test_sms_send: {
                            value: "TEST_SMS_SEND"
                        }
                    }
                },
                {
                    name: "OTHER",
                    actions: {
                        file_transfer_token_save: {
                            value: "FILE_TRANSFER_TOKEN_SAVE",
                            scope: ["provider", "customer"]
                        }
                    }
                }
            ],
            wsSubscriptionType: {
                stats: "STATS",
                state: "STATE"
            },
            entityTable: {
                entityField: {
                    createdTime: {
                        name: 'entity-field.created-time',
                        value: 'createdTime',
                        time: true
                    }
                },
                sortOrder: {
                    asc: {
                        value: 'ASC'
                    },
                    desc: {
                        value: 'DESC'
                    },
                    none: {
                        value: 'NONE'
                    }
                },
                sortType: {
                    frontEnd: {
                        value: 'FRONTEND'
                    },
                    backEnd: {
                        value: 'BACKEND'
                    }
                }
            },
            entityTypeTranslations: {
                "DEVICE": {
                    noEntities: 'device.no-devices-text',
                    selectedEntities: 'device.selected-devices',
                    add: 'device.add',
                    assign: 'device.add-to-multicast-group',
                    bulkProvisioning: 'device.bulk-provisioning-title',
                    details: 'device.device-details',
                    search: 'device.search',
                    name: 'device.device'
                },
                "APPLICATION": {
                    noEntities: 'application.no-applications-text',
                    selectedEntities: 'application.selected-applications',
                    add: 'application.add',
                    details: 'application.application-details',
                    search: 'application.search',
                    name: 'application.application'
                },
                "GATEWAY": {
                    noEntities: 'gateway.no-gateways-text',
                    selectedEntities: 'gateway.selected-gateways',
                    add: 'gateway.add',
                    bulkProvisioning: 'gateway.bulk-provisioning-title',
                    details: 'gateway.gateway-details',
                    search: 'gateway.search',
                    name: 'gateway.gateway'
                },
                "GATEWAY_GROUP": {
                    noEntities: 'gateway-group.no-gateway-groups-text',
                    selectedEntities: 'gateway-group.selected-gateway-groups',
                    add: 'gateway-group.add',
                    details: 'gateway-group.gateway-group-details',
                    search: 'gateway-group.search',
                    name: 'gateway-group.gateway-group'
                },
                "PROVIDER": {
                    noEntities: 'provider.no-providers-text',
                    selectedEntities: 'provider.selected-providers',
                    add: 'provider.add',
                    details: 'provider.provider-details',
                    search: 'provider.search',
                    name: 'provider.provider'
                },
                "CUSTOMER": {
                    noEntities: 'customer.no-customers-text',
                    selectedEntities: 'customer.selected-customers',
                    add: 'customer.add',
                    details: 'customer.customer-details',
                    search: 'customer.search',
                    name: 'customer.customer'
                },
                "SUB_CUSTOMER": {
                    noEntities: 'subCustomer.no-sub-customers-text',
                    selectedEntities: 'subCustomer.selected-sub-customers',
                    add: 'subCustomer.add',
                    details: 'subCustomer.sub-customer-details',
                    search: 'subCustomer.search',
                    name: 'subCustomer.subCustomer'
                },
                "USER": {
                    noEntities: 'user.no-users-text',
                    selectedEntities: 'user.selected-users',
                    add: 'user.add',
                    details: 'user.user-details',
                    search: 'user.search',
                    name: 'user.user'
                },
                "CONVERTER": {
                    noEntities: 'converter.no-converters-text',
                    selectedEntities: 'converter.selected-converters',
                    add: 'converter.add',
                    details: 'converter.converter-details',
                    search: 'converter.search',
                    name: 'converter.converter'
                },
                "CONVERTER_V1": {
                    noEntities: 'converter.no-converters-text',
                    selectedEntities: 'converter.selected-converters',
                    add: 'converter.add',
                    details: 'converter.converter-details',
                    search: 'converter.search',
                    name: 'converter.converter'
                },
                "CONVERTER_V2": {
                    noEntities: 'converter.no-converters-text',
                    selectedEntities: 'converter.selected-converters',
                    add: 'converter.add',
                    details: 'converter.converter-details',
                    search: 'converter.search',
                    name: 'converter.converter'
                },
                "INTEGRATION": {
                    noEntities: 'integration.no-integrations-text',
                    selectedEntities: 'integration.selected-integrations',
                    add: 'integration.add',
                    details: 'integration.integration-details',
                    search: 'integration.search',
                    name: 'integration.integration'
                },
                "PROVIDER_SUBSCRIPTION": {
                    noEntities: 'subscription.no-subscriptions-text',
                    selectedEntities: 'subscription.selected-subscriptions',
                    add: 'subscription.add',
                    details: 'subscription.subscription-details',
                    search: 'subscription.search',
                    name: 'subscription.subscription'
                },
                "CUSTOMER_SUBSCRIPTION": {
                    noEntities: 'subscription.no-subscriptions-text',
                    selectedEntities: 'subscription.selected-subscriptions',
                    add: 'subscription.add',
                    details: 'subscription.subscription-details',
                    search: 'subscription.search',
                    name: 'subscription.subscription'
                },
                "DEVICE_MODEL": {
                    noEntities: 'device-model.no-device-models-text',
                    selectedEntities: 'device-model.selected-device-models',
                    add: 'device-model.add',
                    details: 'device-model.device-model-details',
                    search: 'device-model.search',
                    name: 'device-model.device-model'
                },
                "GATEWAY_MODEL": {
                    noEntities: 'gateway-model.no-gateway-models-text',
                    selectedEntities: 'gateway-model.selected-gateway-models',
                    add: 'gateway-model.add',
                    details: 'gateway-model.gateway-model-details',
                    search: 'gateway-model.search',
                    name: 'gateway-model.gateway-model'
                },
                "MULTICAST_GROUP": {
                    noEntities: 'multicast-group.no-multicast-group-text',
                    selectedEntities: 'multicast-group.selected-multicast-groups',
                    add: 'multicast-group.add',
                    details: 'multicast-group.multicast-group-details',
                    search: 'multicast-group.search',
                    name: 'multicast-group.multicast-group'
                },
            },
            converterType: {
                "CAYENNE_LPP": {
                    value: "CAYENNE_LPP",
                    name: "converter-type.cayenne-lpp"
                },
                "TEK_INDUSTRIAL_SENSOR": {
                    value: "TEK_INDUSTRIAL_SENSOR",
                    name: "converter-type.tek-industrial-sensor"
                },
                "TEK_HOME_SENSOR": {
                    value: "TEK_HOME_SENSOR",
                    name: "converter-type.tek-home-sensor"
                },
                "GLOBAL_SAT_LT100_SENSOR": {
                    value: "GLOBAL_SAT_LT100_SENSOR",
                    name: "converter-type.global-sat-lt100-sensor"
                },
                "ADEUNIS_915_RF_SENSOR": {
                    value: "ADEUNIS_915_RF_SENSOR",
                    name: "converter-type.adeunis-915-rf-sensor"
                },
                "LIBELIUM_SENSOR": {
                    value: "LIBELIUM_SENSOR",
                    name: "converter-type.libelium-sensor"
                },
                "SENSORO_SENSOR": {
                    value: "SENSORO_SENSOR",
                    name: "converter-type.sensoro-sensor"
                },
                "ADEUNIS_8046_RF_SENSOR": {
                    value: "ADEUNIS_8046_RF_SENSOR",
                    name: "converter-type.adeunis-8046-rf-sensor"
                },
                "CUSTOM": {
                    value: "CUSTOM",
                    name: "converter-type.custom"
                },
                "CUSTOM_V2": {
                    value: "CUSTOM_V2",
                    name: "converter-type.customv2"
                }
            },
            deviceClass: {
                "CLASS_A": {
                    value: "CLASS_A",
                    name: "device-class.class-a"
                },
                "CLASS_B": {
                    value: "CLASS_B",
                    name: "device-class.class-b"
                },
                "CLASS_C": {
                    value: "CLASS_C",
                    name: "device-class.class-c"
                }
            },
            gatewayFrequency: {
                "AS_923_1": {
                    value: "AS_923_1",
                    name: "gateway-frequency.as-923-1"
                },
                "AS_923_2": {
                    value: "AS_923_2",
                    name: "gateway-frequency.as-923-2"
                },
                "AS_923_3": {
                    value: "AS_923_3",
                    name: "gateway-frequency.as-923-3"
                },
                "AS_923_4": {
                    value: "AS_923_4",
                    name: "gateway-frequency.as-923-4"
                },
                "AS_920_923": {
                    value: "AS_920_923",
                    name: "gateway-frequency.as-920-923"
                },
                "AS_923_925": {
                    value: "AS_923_925",
                    name: "gateway-frequency.as-923-925"
                },
                "US_902_928": {
                    value: "US_902_928",
                    name: "gateway-frequency.us-902-928",
                    info: {
                        frequencyBand: "902-928MHz",
                        channels: "64+8+8",
                        channelBwUp: "125/500kHz",
                        channelBwDn: "500kHz",
                        txPowerUp: "+20dBm (+30dBm allowed)",
                        txPowerDn: "+27dBm",
                        sfUp: "7-10",
                        dataRate: "980bps-21.9kbps",
                        linkBudgetUp: "154dB",
                        linkBudgetDn: "157dB"
                    }
                },
                "EU_863_870": {
                    value: "EU_863_870",
                    name: "gateway-frequency.eu-863-870",
                    info: {
                        frequencyBand: "867-869MHz",
                        channels: "10",
                        channelBwUp: "125/250kHz",
                        channelBwDn: "125kHz",
                        txPowerUp: "+14dBm",
                        txPowerDn: "+14dBm",
                        sfUp: "7-12",
                        dataRate: "250bps-50kbps",
                        linkBudgetUp: "155dB",
                        linkBudgetDn: "155dB"
                    }
                },
                "CN_470_510": {
                    value: "CN_470_510",
                    name: "gateway-frequency.cn-470-510",
                    info: {
                        frequencyBand: "470-510MHz",
                        channels: "96+48",
                        channelBwUp: "125/500kHz",
                        channelBwDn: "500kHz",
                        txPowerUp: "+20dBm (+30dBm allowed)",
                        txPowerDn: "+27dBm",
                        sfUp: "7-10",
                        dataRate: "980bps-21.9kbps",
                        linkBudgetUp: "154dB",
                        linkBudgetDn: "157dB"
                    }
                },
                "AU_915_928": {
                    value: "AU_915_928",
                    name: "gateway-frequency.au-915-928",
                    info: {
                        frequencyBand: "915-928MHz",
                        channels: "64+8+8",
                        channelBwUp: "125/500kHz",
                        channelBwDn: "500kHz",
                        txPowerUp: "+20dBm (+30dBm allowed)",
                        txPowerDn: "+27dBm",
                        sfUp: "7-10",
                        dataRate: "980bps-21.9kbps",
                        linkBudgetUp: "154dB",
                        linkBudgetDn: "157dB"
                    }
                },
                "RU_864_870": {
                    value: "RU_864_870",
                    name: "gateway-frequency.ru-864-870",
                    info: {
                        frequencyBand: "864-870MHz",
                        dataRate: "300bps-5kbps",
                    }
                },
                "IN_865_867": {
                    value: "IN_865_867",
                    name: "gateway-frequency.in-865-867",
                    info: {
                        frequencyBand: "865-867MHz",
                        dataRate: "300bps-5kbps",
                    }
                },
                "ISR_915_917": {
                    value: "ISR_915_917",
                    name: "gateway-frequency.isr-915-917",
                    info: {
                        frequencyBand: "915-917MHz",
                        dataRate: "300bps-5kbps",
                    }
                },
                "KR_920_923": {
                    value: "KR_920_923",
                    name: "gateway-frequency.kr-920-923",
                    info: {
                        frequencyBand: "920-923MHz",
                        dataRate: "300bps-5kbps",
                    }
                }
            },
            qosValue: {
                "AT_MOST_ONCE": {
                    value: "AT_MOST_ONCE",
                    name: "integration-push-qos.at-most-once"
                },
                "AT_LEAST_ONCE": {
                    value: "AT_LEAST_ONCE",
                    name: "integration-push-qos.at-least-once"
                },
                "EXACTLY_ONCE": {
                    value: "EXACTLY_ONCE",
                    name: "integration-push-qos.exactly-once"
                }
            },
            integrationType: {
                "HTTP": {
                    value: "HTTP",
                    name: "integration-type.http"
                },
                "HTTP_V2": {
                    value: "HTTP_V2",
                    name: "integration-type.http_v2"
                },
                "TAGO_IO": {
                    value: "TAGO_IO",
                    name: "integration-type.tago_io"
                },
                "MQTT": {
                    value: "MQTT",
                    name: "integration-type.mqtt"
                },
                "MQTT_V2": {
                    value: "MQTT_V2",
                    name: "integration-type.mqtt_v2"
                },
                "MQTT_V2_EMBEDDED": {
                    value: "MQTT_V2_EMBEDDED",
                    name: "integration-type.mqtt_v2_embedded"
                },
                "THINGSBOARD": {
                    value: "THINGSBOARD",
                    name: "integration-type.thingsboard"
                },
                "AZURE_IOT_CENTRAL": {
                    value: "AZURE_IOT_CENTRAL",
                    name: "integration-type.azure-iot-central"
                }
            },
            configurationType: {
                "GENERAL": {
                    value: "GENERAL",
                    name: "configuration-type.general"
                },
                "FREQUENCY": {
                    value: "FREQUENCY",
                    name: "configuration-type.frequency"
                },
                "ANTENNA": {
                    value: "ANTENNA",
                    name: "configuration-type.antenna"
                },
                "UPGRADE_SERVERS": {
                    value: "UPGRADE_SERVERS",
                    name: "configuration-type.upgrade-servers"
                },
                "AUTOMATIC_UPDATES": {
                    value: "AUTOMATIC_UPDATES",
                    name: "configuration-type.automatic-updates"
                }
            },
            contentType: {
                "JSON": {
                    value: "JSON",
                    name: "content-type.json",
                    code: "json"
                },
                "TEXT": {
                    value: "TEXT",
                    name: "content-type.text",
                    code: "text"
                },
                "BINARY": {
                    value: "BINARY",
                    name: "content-type.binary",
                    code: "text"
                }
            },
            fileType: {
                CSV: {
                    mimeType: 'attachment/csv',
                    extension: 'csv'
                },
                PEM: {
                    mimeType: 'attachment/pem',
                    extension: 'pem'
                },
                KEY: {
                    mimeType: 'attachment/key',
                    extension: 'key'
                },
                CRT: {
                    mimeType: 'attachment/crt',
                    extension: 'crt'
                },
                CER: {
                    mimeType: 'attachment/cer',
                    extension: 'cer'
                },
                TXT: {
                    mimeType: 'text/plain',
                    extension: 'txt'
                }
            },
            configScope: {
                gateway: {
                    value: "gateway",
                    name: "configuration.gateway-scope"
                },
                group: {
                    value: "group",
                    name: "configuration.group-scope"
                }
            },
            configSyncStatus: {
                synced: {
                    value: "synced",
                    name: "configuration.synced"
                },
                notSynced: {
                    value: "notSynced",
                    name: "configuration.not-synced"
                }
            },
            gatewayCommand: {
                reboot: {
                    value: "reboot",
                    name: "gateway-command.reboot"
                },
                ping: {
                    value: "ping",
                    name: "gateway-command.ping"
                },
                getPublicKey: {
                    value: "getPublicKey",
                    name: "gateway-command.get-public-key"
                },
                reverseSsh: {
                    value: "reverseSsh",
                    name: "gateway-command.reverse-ssh"
                },
                stopReverseSsh: {
                    value: "stopReverseSsh",
                    name: "gateway-command.stop-reverse-ssh"
                },
                getAntennasCount: {
                    value: "getAntennasCount",
                    name: "gateway-command.get-antennas-count"
                }
            },
            gatewayCommandNotSupported: {
                value: 'not_supported',
                name: 'gateway-command.not-supported'
            },
            backupsGatewayCommand: {
                getBackups: {
                    value: 'getBackups'
                },
                restoreBackup: {
                    value: 'restoreBackup'
                },
                createBackup: {
                    value: 'createBackup'
                }
            },
            firewallGatewayCommand: {
                getFirewallConfiguration: {
                    value: 'getFirewallConfiguration'
                },
                setFirewallConfiguration: {
                    value: 'setFirewallConfiguration'
                }
            },
            spectrumAnalyzerCommand: {
                setSpectrumAnalyzerParams: {
                    value: 'setSpectrumAnalyzerParams'
                },
                getSpectrumAnalyzerOutput: {
                    value: 'getSpectrumAnalyzerOutput'
                }
            },
            spectralScanCommand: {
                getSpectralScanParams: {
                    value: 'getSpectralScanParams'
                },
                executeSpectralScan: {
                    value: 'executeSpectralScan'
                },
                getSpectralScanProgress: {
                    value: 'getSpectralScanProgress'
                },
                getSpectralScanResults: {
                    value: 'getSpectralScanResults'
                }
            },
            radioStatisticsCommand: {
                getRadioStatistics: {
                    value: 'getRadioStatistics'
                },
                resetRadioStatisticsCounters: {
                    value: 'resetRadioStatisticsCounters'
                }
            },
            gatewayInfoCommand: {
                getGatewayInfo: {
                    value: 'getGatewayInfo'
                }
            },
            softwareCommand: {
                getSoftwareVersions: {
                    value: 'getSoftwareVersions'
                },
                getBspStatus: {
                    value: 'getBspStatus'
                },
                getUpgradableSoftware: {
                    value: 'getUpgradableSoftware'
                },
                getInstallableSoftware: {
                    value: 'getInstallableSoftware'
                },
                upgradeSoftware: {
                    value: 'upgradeSoftware'
                },
                installSoftware: {
                    value: 'installSoftware'
                },
                getInstallStatus: {
                    value: 'getInstallStatus'
                },
                getUpgradeStatus: {
                    value: 'getUpgradeStatus'
                },
                getLastInstallUpgradeStatus: {
                    value: 'getLastInstallUpgradeStatus'
                }
            },
            wirelessModemCommand: {
                getWmDeviceInformation: {
                    value: 'getWmDeviceInformation'
                },
                getWmHomeNetworkBranch: {
                    value: 'getWmHomeNetworkBranch'
                },
                getWmRfInformation: {
                    value: 'getWmRfInformation'
                },
                getWmNetworkInfo: {
                    value: 'getWmNetworkInfo'
                },
                setWmPreferredNetwork: {
                    value: 'setWmPreferredNetwork'
                },
                getWmActiveProfileParameters: {
                    value: 'getWmActiveProfileParameters'
                },
                getWmCallStatistics: {
                    value: 'getWmCallStatistics'
                },
                getWmApns: {
                    value: 'getWmApns'
                },
                addWmApn: {
                    value: 'addWmApn'
                },
                deleteWmApn: {
                    value: 'deleteWmApn'
                },
                getWmStatusApn: {
                    value: 'getWmStatusApn'
                },
                updateWmApn: {
                    value: 'updateWmApn'
                },
                installWmLocalFirmware: {
                    value: 'installWmLocalFirmware'
                },
                installWmLocalFirmwareStatus: {
                    value: 'installWmLocalFirmwareStatus'
                },
                wipeUploadDirectory: {
                    value: 'wipeUploadDirectory'
                },
                upgradeWmFirmware: {
                    value: 'upgradeWmFirmware'
                },
                uploadRemoteWmFirmware: {
                    value: 'uploadRemoteWmFirmware'
                }
            },
            wanCommand: {
                getConnectivityTypes: {
                    value: 'getConnectivityTypes'
                },
                setPreferredFallbackConnectivityType: {
                    value: 'setPreferredFallbackConnectivityType'
                },
                setPreferredPingIpAddress: {
                    value: 'setPreferredPingIpAddress'
                },
                getPreferredPingIpAddress: {
                    value: 'getPreferredPingIpAddress'
                }
            },
            fileTransferCommand: {
                fileUploadStart: {
                    value: 'fileUploadStart'
                },
                fileUploadChunk: {
                    value: 'fileUploadChunk'
                },
                fileUploadStop: {
                    value: 'fileUploadStop'
                }
            },
            spectrumAnalyzerAntenna: {
                antenna0: {
                    value: 'antenna0',
                    name: 'spectrum-analyzer.antenna0'
                },
                antenna1: {
                    value: 'antenna1',
                    name: 'spectrum-analyzer.antenna1'
                },
                both: {
                    value: 'both',
                    name: 'spectrum-analyzer.antenna-both'
                }
            },
            spectralScanAntenna: {
                antenna0: {
                    value: 'antenna0',
                    name: 'spectrum-analyzer.antenna0'
                },
                antenna1: {
                    value: 'antenna1',
                    name: 'spectrum-analyzer.antenna1'
                }
            },
            firewall: {
                chain: {
                    input: 'INPUT',
                    output: 'OUTPUT'
                },
                target: {
                    accept: 'ACCEPT',
                    drop: 'DROP',
                    reject: 'REJECT'
                }
            },
            alarmRuleScope: {
                gateway: 'gateway',
                device: 'device'
            },
            gwAlarmRuleTriggerType: {
                "GW_OFFLINE": {
                    value: "GW_OFFLINE",
                    name: "alarm-rule.trigger-gw-offline",
                    group: "GATEWAY"
                },
                "GW_ONLINE": {
                    value: "GW_ONLINE",
                    name: "alarm-rule.trigger-gw-online",
                    group: "GATEWAY"
                },
                "GW_MQTT_DISCONNECTED": {
                    value: "GW_MQTT_DISCONNECTED",
                    name: "alarm-rule.trigger-gw-mqtt-disconnected",
                    group: "GATEWAY"
                },
                "GW_MQTT_CONNECTED": {
                    value: "GW_MQTT_CONNECTED",
                    name: "alarm-rule.trigger-gw-mqtt-connected",
                    group: "GATEWAY"
                },
                "GW_FSK_OFFLINE": {
                    value: "GW_FSK_OFFLINE",
                    name: "alarm-rule.trigger-gw-fsk-offline",
                    group: "GATEWAY"
                },
                "GW_FSK_ONLINE": {
                    value: "GW_FSK_ONLINE",
                    name: "alarm-rule.trigger-gw-fsk-online",
                    group: "GATEWAY"
                },
                "GW_FSK_MQTT_DISCONNECTED": {
                    value: "GW_FSK_MQTT_DISCONNECTED",
                    name: "alarm-rule.trigger-gw-fsk-mqtt-disconnected",
                    group: "GATEWAY"
                },
                "GW_FSK_MQTT_CONNECTED": {
                    value: "GW_FSK_MQTT_CONNECTED",
                    name: "alarm-rule.trigger-gw-fsk-mqtt-connected",
                    group: "GATEWAY"
                },
                "GW_ALARM": {
                    value: "GW_ALARM",
                    name: "alarm-rule.trigger-gw-alarm",
                    isEvent: true,
                    group: "GATEWAY"
                },
                "GW_FAULT": {
                    value: "GW_FAULT",
                    name: "alarm-rule.trigger-gw-fault",
                    isEvent: true,
                    group: "GATEWAY"
                }
            },
            devAlarmRuleTriggerType: {
                "DEV_OFFLINE": {
                    value: "DEV_OFFLINE",
                    name: "alarm-rule.trigger-dev-offline",
                    group: "DEVICE"
                },
                "DEV_ONLINE": {
                    value: "DEV_ONLINE",
                    name: "alarm-rule.trigger-dev-online",
                    group: "DEVICE"
                },
                "DOWNLINK_QUEUE_SIZE_THRESHOLD_EXCEEDED": {
                    value: "DOWNLINK_QUEUE_SIZE_THRESHOLD_EXCEEDED",
                    name: "alarm-rule.trigger-downlink-queue-size-threshold-exceeded",
                    group: "DEVICE"
                },
                "DOWNLINK_QUEUE_SIZE_THRESHOLD_NOT_EXCEEDED": {
                    value: "DOWNLINK_QUEUE_SIZE_THRESHOLD_NOT_EXCEEDED",
                    name: "alarm-rule.trigger-downlink-queue-size-threshold-not-exceeded",
                    group: "DEVICE"
                },
                "DOWNLINK_QUEUE_IS_FULL": {
                    value: "DOWNLINK_QUEUE_IS_FULL",
                    name: "alarm-rule.trigger-downlink-queue-is-full",
                    group: "DEVICE"
                },
                "DOWNLINK_QUEUE_IS_NOT_FULL": {
                    value: "DOWNLINK_QUEUE_IS_NOT_FULL",
                    name: "alarm-rule.trigger-downlink-queue-is-not-full",
                    group: "DEVICE"
                },
                "LARGE_DL_DROPPED": {
                    value: "LARGE_DL_DROPPED",
                    name: "alarm-rule.trigger-large-dl-dropped",
                    group: "DEVICE"
                },
                "LARGE_DL_DROPPING_STOPPED": {
                    value: "LARGE_DL_DROPPING_STOPPED",
                    name: "alarm-rule.trigger-large-dl-dropping-stopped",
                    group: "DEVICE"
                },
                "INTEGRATION_IS_CONNECTED": {
                    value: "INTEGRATION_IS_CONNECTED",
                    name: "alarm-rule.trigger-integration-connected",
                    group: "INTEGRATION"
                },
                "INTEGRATION_IS_DISCONNECTED": {
                    value: "INTEGRATION_IS_DISCONNECTED",
                    name: "alarm-rule.trigger-integration-disconnected",
                    group: "INTEGRATION"
                },
                "ENCODER_BANNED": {
                    value: "ENCODER_BANNED",
                    name: "alarm-rule.trigger-encoder-banned",
                    group: "CONVERTER"
                },
                "ENCODER_UNBANNED": {
                    value: "ENCODER_UNBANNED",
                    name: "alarm-rule.trigger-encoder-unbanned",
                    group: "CONVERTER"
                },
                "DECODER_BANNED": {
                    value: "DECODER_BANNED",
                    name: "alarm-rule.trigger-decoder-banned",
                    group: "CONVERTER"
                },
                "DECODER_UNBANNED": {
                    value: "DECODER_UNBANNED",
                    name: "alarm-rule.trigger-decoder-unbanned",
                    group: "CONVERTER"
                }
            },
            notificationType: {
                "EMAIL": {
                    value: "EMAIL",
                    name: "alarm-rule.notification-email"
                },
                "SMS": {
                    value: "SMS",
                    name: "alarm-rule.notification-sms"
                },
                "MQTT": {
                    value: "MQTT",
                    name: "alarm-rule.notification-mqtt"
                }
            },
            eventType: {
                "ALARM": {
                    value: "ALARM",
                    name: "event.alarms",
                    typeName: "event.alarm"
                },
                "FAULT": {
                    value: "FAULT",
                    name: "event.faults",
                    typeName: "event.fault"
                },
                "EVENT": {
                    value: "EVENT",
                    name: "event.events",
                    typeName: "event.event"
                },
                "OFFLINE": {
                    value: "OFFLINE",
                    name: "event.offline",
                    typeName: "event.offline"
                }
            },
            severity: {
                "CRITICAL": {
                    value: "CRITICAL",
                    name: "event.severity-critical"
                },
                "MAJOR": {
                    value: "MAJOR",
                    name: "event.severity-major"
                },
                "MINOR": {
                    value: "MINOR",
                    name: "event.severity-minor"
                }
            },
            eventState: {
                "CLEAR": {
                    value: "CLEAR",
                    name: "event.state-clear"
                },
                "RAISED": {
                    value: "RAISED",
                    name: "event.state-raised"
                }
            },
            authMethodType: {
                "NO_AUTH": {
                    value: "NO_AUTH",
                    name: "integration.auth-method-type.no-auth"
                },
                "BASIC_AUTH": {
                    value: "BASIC_AUTH",
                    name: "integration.auth-method-type.basic-auth"
                }
            },
            credentialsTypes: {
                basic: {
                    value: 'BASIC',
                    name: 'credentials.basic'
                },
                x509_certificate: {
                    value: 'X509_CERTIFICATE',
                    name: 'credentials.x509_certificate'
                },
                tektelic_certificate: {
                    value: 'TEKTELIC_CERTIFICATE',
                    name: 'credentials.tektelic_certificate'
                }
            },
            chMaskOptions: {
                "notDefined": {
                    name: "networkSettings.not-defined-channel-mask",
                    value: "notDefined"
                },
                "channels64": {
                    name: "networkSettings.64-channel",
                    value: "channels64"
                },
                "channels8": {
                    name: "networkSettings.8-channel",
                    value: "channels8"
                },
                "custom": {
                    name: "networkSettings.custom-channel-mask",
                    value: "custom"
                }
            },
            channelMaskOptionsData: {
                "channels8": [
                    {
                        chMask: '0x0001',
                        chMaskCntl: '0x07'
                    },
                    {
                        chMask: '0x00FF',
                        chMaskCntl: '0x00'
                    }
                ],
                "channels64": [
                    {
                        chMask: '0x00FF',
                        chMaskCntl: '0x06'
                    }
                ],
                "notDefined": []
            },
            valueType: {
                string: {
                    value: "string",
                    name: "value.string",
                    icon: "mdi:format-text"
                },
                integer: {
                    value: "integer",
                    name: "value.integer",
                    icon: "mdi:numeric"
                },
                double: {
                    value: "double",
                    name: "value.double",
                    icon: "mdi:numeric"
                },
                boolean: {
                    value: "boolean",
                    name: "value.boolean",
                    icon: "mdi:checkbox-marked-outline"
                }
            },
            smsProvider: {
                "TWILIO": {
                    value: "TWILIO",
                    name: "admin.sms-twilio"
                }
            },
            subscriptionError: {
                "LIMIT_REACHED": {
                    "MAX_PROVIDER_GATEWAYS": "subscription-error.limit-reached.max-provider-gateways",
                    "MAX_CUSTOMER_GATEWAYS": "subscription-error.limit-reached.max-customer-gateways",
                    "MAX_PROVIDER_APPLICATIONS": "subscription-error.limit-reached.max-provider-applications",
                    "MAX_CUSTOMER_APPLICATIONS": "subscription-error.limit-reached.max-customer-applications",
                    "MAX_PROVIDER_DEVICES": "subscription-error.limit-reached.max-provider-devices",
                    "MAX_CUSTOMER_DEVICES": "subscription-error.limit-reached.max-customer-devices",
                    "MAX_PROVIDER_INTEGRATIONS": "subscription-error.limit-reached.max-provider-integrations",
                    "MAX_CUSTOMER_INTEGRATIONS": "subscription-error.limit-reached.max-customer-integrations",
                    "MAX_CUSTOMERS": "subscription-error.limit-reached.max-customers",
                    "MAX_SUB_CUSTOMERS": "subscription-error.limit-reached.max-sub-customers",
                    "PROVIDER_SUBSCRIPTION_VIOLATION": "subscription-error.limit-reached.provider-subscription-violation",
                    "CUSTOMER_SUBSCRIPTION_VIOLATION": "subscription-error.limit-reached.customer-subscription-violation"
                }
            },
            software: {
                mode: {
                    swList: {
                        title: 'software.software-versions',
                        noDataPrompt: 'software.no-components-prompt'
                    },
                    upgradableList: {
                        title: 'software.upgradable-software',
                        selection: true,
                        upgrade: true,
                        showNewVer: true,
                        hasSpecial: true,
                        noDataPrompt: 'software.no-upgradable-prompt',
                        selectedText: 'software.selected-upgradable'
                    },
                    installableList: {
                        title: 'software.installable-software',
                        selection: true,
                        upgrade: false,
                        noDataPrompt: 'software.no-installable-prompt',
                        selectedText: 'software.selected-installable'
                    }
                },
                verType: {
                    short: {
                        name: 'software.ver-type-short',
                        value: 'short',
                        id: 0,
                    },
                    full: {
                        name: 'software.ver-type-full',
                        value: 'full',
                        id: 1
                    }
                },
                bspStatus: {
                    0: {
                        name: 'software.bsp-status-success'
                    },
                    90000: {
                        name: 'software.bsp-status-upgrade-busy'
                    },
                    90001: {
                        name: 'software.bsp-status-bsp-upgrade-busy'
                    },
                    90002: {
                        name: 'software.bsp-status-bsp-status-never-performed'
                    },
                    90003: {
                        name: 'software.bsp-status-bsp-latest'
                    },
                    90004: {
                        name: 'software.bsp-status-bsp-upgrade-error'
                    },
                    1000001: {
                        name: 'software.bsp-status-break-lock'
                    }
                },
                upgradeStatus: {
                    0: {
                        name: "software.upgrade-status-success"
                    },
                    1: {
                        name: "software.upgrade-status-could-not-set-default-destination"
                    },
                    2: {
                        name: "software.upgrade-status-error-parsing-config-file"
                    },
                    3: {
                        name: "software.upgrade-status-could-not-obtain-temporary-directory"
                    },
                    4: {
                        name: "software.upgrade-status-could-not-obtain-administrative-lock"
                    },
                    5: {
                        name: "software.upgrade-status-unsatisfied-dependencies"
                    },
                    6: {
                        name: "software.upgrade-status-is-essential"
                    },
                    7: {
                        name: "software.upgrade-status-has-dependents"
                    },
                    8: {
                        name: "software.upgrade-status-has-no-candidate"
                    },
                    9: {
                        name: "software.upgrade-status-package-has-no-available-architecture"
                    },
                    10: {
                        name: "software.upgrade-status-not-trusted"
                    },
                    11: {
                        name: "software.upgrade-status-download-error"
                    },
                    12: {
                        name: "software.upgrade-status-conflicts"
                    },
                    13: {
                        name: "software.upgrade-status-already-installed"
                    },
                    14: {
                        name: "software.upgrade-status-dependencies"
                    },
                    15: {
                        name: "software.upgrade-status-no-downgrade"
                    },
                    16: {
                        name: "software.upgrade-status-out-of-space"
                    },
                    17: {
                        name: "software.upgrade-status-bad-signature"
                    },
                    18: {
                        name: "software.upgrade-status-md5-error"
                    },
                    19: {
                        name: "software.upgrade-status-internal-error"
                    },
                    65280: {
                        name: "software.upgrade-status-unknown-error"
                    },
                    90000: {
                        name: "software.upgrade-status-tt-upgrade-busy"
                    },
                    90001: {
                        name: "software.upgrade-status-tt-bsp-upgrade-busy"
                    },
                    90002: {
                        name: "software.upgrade-status-tt-bsp-status-never-performed"
                    },
                    90003: {
                        name: "software.upgrade-status-tt-bsp-latest"
                    },
                    90004: {
                        name: "software.upgrade-status-tt-bsp-upgrade-error"
                    },
                    90005: {
                        name: "software.upgrade-status-tt-general-upgrade-failure"
                    },
                    1000001: {
                        name: "software.upgrade-status-start-upgrade"
                    }
                },
                installStatus: {
                    0: {
                        name: "software.install-status-success"
                    },
                    1: {
                        name: "software.install-status-could-not-set-default-destination"
                    },
                    2: {
                        name: "software.install-status-error-parsing-config-file"
                    },
                    3: {
                        name: "software.install-status-could-not-obtain-temporary-directory"
                    },
                    4: {
                        name: "software.install-status-could-not-obtain-administrative-lock"
                    },
                    5: {
                        name: "software.install-status-unsatisfied-dependencies"
                    },
                    6: {
                        name: "software.install-status-is-essential"
                    },
                    7: {
                        name: "software.install-status-has-dependents"
                    },
                    8: {
                        name: "software.install-status-has-no-candidate"
                    },
                    9: {
                        name: "software.install-status-package-has-no-available-architecture"
                    },
                    10: {
                        name: "software.install-status-not-trusted"
                    },
                    11: {
                        name: "software.install-status-download-error"
                    },
                    12: {
                        name: "software.install-status-conflicts"
                    },
                    13: {
                        name: "software.install-status-already-installed"
                    },
                    14: {
                        name: "software.install-status-dependencies"
                    },
                    15: {
                        name: "software.install-status-no-downgrade"
                    },
                    16: {
                        name: "software.install-status-out-of-space"
                    },
                    17: {
                        name: "software.install-status-bad-signature"
                    },
                    18: {
                        name: "software.install-status-md5-error"
                    },
                    19: {
                        name: "software.install-status-internal-error"
                    },
                    65280: {
                        name: "software.install-status-unknown-error"
                    },
                    90000: {
                        name: "software.install-status-tt-install-busy"
                    },
                    90005: {
                        name: "software.install-status-tt-general-install-failure"
                    },
                    1000001: {
                        name: "software.install-status-start-install"
                    }
                }
            },
            translate: {
                customTranslationsPrefix: "custom."
            },
            gatewayMsgType: {
                "GW_STATISTICS": {
                    value: "GW_STATISTICS",
                    name: "gateway-log.gw-statistics",
                },
                "GW_EVENT": {
                    value: "GW_EVENT",
                    name: "gateway-log.gw-event"
                },
                "GW_RPC_COMMAND": {
                    value: "GW_RPC_COMMAND",
                    name: "gateway-log.gw-rpc-command"
                },
                "GW_RPC_RESPONSE": {
                    value: "GW_RPC_RESPONSE",
                    name: "gateway-log.gw-rpc-response"
                },
                "GW_CONFIGURATION_UPDATE": {
                    value: "GW_CONFIGURATION_UPDATE",
                    name: "gateway-log.gw-configuration-update"
                },
                "GW_CONFIGURATION_REQUEST": {
                    value: "GW_CONFIGURATION_REQUEST",
                    name: "gateway-log.gw-configuration-request"
                },
                "GW_FIRMWARE_REPORTED": {
                    value: "GW_FIRMWARE_REPORTED",
                    name: "gateway-log.gw-firmware-reported"
                },
                "GW_CONFIGURATION_REPORTED": {
                    value: "GW_CONFIGURATION_REPORTED",
                    name: "gateway-log.gw-configuration-reported"
                },
                "JOIN_REQUEST": {
                    value: "JOIN_REQUEST",
                    name: "gateway-log.join-request"
                },
                "JOIN_ACCEPT": {
                    value: "JOIN_ACCEPT",
                    name: "gateway-log.join-accept"
                },
                "UNCONFIRMED_DATA_UP": {
                    value: "UNCONFIRMED_DATA_UP",
                    name: "gateway-log.unconfirmed-data-up"
                },
                "UNCONFIRMED_DATA_DOWN": {
                    value: "UNCONFIRMED_DATA_DOWN",
                    name: "gateway-log.unconfirmed-data-down"
                },
                "CONFIRMED_DATA_UP": {
                    value: "CONFIRMED_DATA_UP",
                    name: "gateway-log.confirmed-data-up"
                },
                "CONFIRMED_DATA_DOWN": {
                    value: "CONFIRMED_DATA_DOWN",
                    name: "gateway-log.confirmed-data-down"
                }
            },
            bulk_provisioning: {
                gw_id_column: "GW ID",
                device_dev_eui_column: "DEVEUI",
                device_app_eui_column: "APPEUI",
                device_app_key_column: "APPKEY",
                mqtt_username_column: "MQTT USERNAME",
                mqtt_password_column: "MQTT PASSWORD",
            },
            data_rate: [
                {value: 0, name: "DR0"},
                {value: 1, name: "DR1"},
                {value: 2, name: "DR2"},
                {value: 3, name: "DR3"},
                {value: 4, name: "DR4"},
                {value: 5, name: "DR5"},
                {value: 6, name: "DR6"},
                {value: 7, name: "DR7"},
                {value: 8, name: "DR8"},
                {value: 9, name: "DR9"},
                {value: 10, name: "DR10"},
                {value: 11, name: "DR11"},
                {value: 12, name: "DR12"},
                {value: 13, name: "DR13"},
                {value: 14, name: "DR14"},
                {value: 15, name: "DR15"},
                {value: 16, name: "DR16"},
            ],
            tx_power: [
                {value: 0, name: "0 (Max Power)"},
                {value: 1, name: "1"},
                {value: 2, name: "2"},
                {value: 3, name: "3"},
                {value: 4, name: "4"},
                {value: 5, name: "5"},
                {value: 6, name: "6"},
                {value: 7, name: "7"},
                {value: 8, name: "8"},
                {value: 9, name: "9"},
                {value: 10, name: "10"},
            ],
            nb_trans: [
                {value: 1, name: "1"},
                {value: 2, name: "2"},
                {value: 3, name: "3"},
            ],
            grace_period: [
                {value: 1, name: "1"},
                {value: 2, name: "2"},
                {value: 3, name: "3"},
                {value: 4, name: "4"},
                {value: 5, name: "5"},
                {value: 6, name: "6"},
                {value: 7, name: "7"},
                {value: 8, name: "8"},
                {value: 9, name: "9"},
                {value: 10, name: "10"},
                {value: 11, name: "11"},
                {value: 12, name: "12"},
                {value: 13, name: "13"},
                {value: 14, name: "14"},
                {value: 15, name: "15"},
                {value: 16, name: "16"},
                {value: 17, name: "17"},
                {value: 18, name: "18"},
                {value: 19, name: "19"},
                {value: 20, name: "20"},
            ],
            broadcastEvents: {
                "GATEWAY_GROUP": {
                    loadGwSwVersions: "loadGwSwVersions",
                    loadGwConfigurations: "loadGwConfigurations"
                }
            },
            clientCustomizations: {
                "BI": {
                    prefix: "bi.",
                    ssoLoginButton: 'login.sso-login'
                },
                "default_sso_realm_customization": {
                    ssoLoginButton: 'login.sso-login'
                }
            }
        }
    ).name;



// WEBPACK FOOTER //
// ./src/app/common/types.constant.js